/**
 * AVA-795: the inspection import/populate result in plain words, for the Inspections admin screen.
 * The server returns { created, updated, facilityOwned, groupOwned, refused: [{ inspection, reason }] }.
 */
const REFUSED_SHOWN = 3;

function plural(count, word) {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}

/** The success line: what was created and updated, and how many of them the group shares. */
export function importDoneMessage(result) {
  if (!result || typeof result !== 'object') return 'Inspections updated successfully.';
  const parts = [`${result.created || 0} created`, `${result.updated || 0} updated`];
  const shared = result.groupOwned ? `, ${result.groupOwned} of them shared by the facility group` : '';
  return `Inspections: ${parts.join(', ')}${shared}.`;
}

/** The warning for refused rows, or null when none: the first few with their reason, then a count. */
export function importRefusedMessage(result) {
  const refused = (result && result.refused) || [];
  if (!refused.length) return null;
  const shown = refused.slice(0, REFUSED_SHOWN).map((row) => `${row.inspection}: ${row.reason}`);
  const more = refused.length > REFUSED_SHOWN ? ` And ${refused.length - REFUSED_SHOWN} more.` : '';
  return `${plural(refused.length, 'row')} not imported. ${shown.join(' ')}${more}`;
}
